import { createUseStyles } from 'react-jss';

const styles = createUseStyles(() => {
  return {
    appCardLogo: {
      height: '50px',
    },
  };
});

export default styles;
